<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()">
            Adicionar Cronograma Desembolso Parceiro
        </b-button>
        <cronograma-desembolso-parceiro-form
            operacaoProp="I"
            :pleito="pleito"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></cronograma-desembolso-parceiro-form>
    </div>
</template>

<script>
import CronogramaDesembolsoParceiroForm from './CronogramaDesembolsoParceiroForm'

export default {
    components: {
        CronogramaDesembolsoParceiroForm
    },

    props: {
        pleito: {
            type: Object,
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(cronograma){
            this.$store.dispatch('addRequest')
            let cronogramaDto = {
                pleitoId : cronograma.pleitoId,
                parcela: cronograma.parcela,
                mes: cronograma.mes,
                valor: cronograma.valor,
                descritivo: cronograma.descritivo,
            }
            this.dataServicos.inserirCronogramaDesembolsoParceiro(cronogramaDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Cronograma inserido com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
